import { post , get, getBody, postFile } from '../axiosconfig'
import qs from 'qs'
export default {
  // 获取密钥
  getOauthSecret(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/secret/get', params)
  },
  // 密码验证
  checkPass(params){
    return post('/zsc/web/console/user/check_password', params)
  },
  // 财务概览
  getOverview(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/account/info', params)
  },
  // 月度账单
  getMonth(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/bill/stats', params)
  },
  // 充值
  recharge(params){
    // params = qs.stringify(params)
    return post('/api/wallet/recharge', params)
  },
  // 账单
  getBill(params){
    // params = qs.stringify(params)
    return post('/api/invoice/bill', params)
  },
  // 订单列表
  getOrderList(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/order/list', params)
  },
  // 资源包列表
  getResourceList(params){
    // params = qs.stringify(params)
    return post('/api/invoice/Resource', params)
  },
  // 产品信息
  getCloudInfo(params){
    params = qs.stringify(params)
    return get('/api/cloud/info', params)
  },
  // 产品信息
  getCloudInfoBysno(params){
    // params = qs.stringify(params)
    return post('/api/cloud/infoBysno', params)
  },
  // 购买
  createOrder(params){
    return post('/api/order/create', params)
  },
  // 升级
  upgradeOrder(params){
    return post('/api/order/upgrade', params)
  },
  // 续费
  renewOrder(params){
    return post('/api/order/renew', params)
  },
  // 获取订单详情
  getOrderDetail(params){
    return post('/api/order/detail', params)
  },
  // 支付
  sendPay(params){
    return post('/api/pay', params)
  },
  // 充值
  sendRecharge(params){
    return post('/zsc/web/console/pay/apply', params)
  },
  // 上传凭证
  sendRechargeUpload(params,headers) {
    return postFile('/zsc/web/console/pay/apply/remit', params, headers)
  },
  // 用户账户
  getWalletInfo(params){
    return post('/api/wallet/info', params)
  },

  // 收支明细
  getWalletLog(params){
    params = qs.stringify(params);
    return get('/zsc/web/console/bill/list', params)
  },

  // 可用额度预警
  getQuota(params){
    return post('/zsc/web/console/account/update', params)
  },

  // 延停服务
  getDeferstop(params){
    return post('/zsc/web/console/account/update', params)
  },

  // 高额消费列表
  getConsumeList(params){
    return post('/api/invoice/warn/consume/list', params)
  },

  // 新增高额消费
  getConsumeSave(params){
    return post('/api/invoice/warn/consume/save', params)
  },

  // 编辑高额消费
  getConsumeEdit(params){
    return post('/api/invoice/warn/consume/edit', params)
  },

  // 删除高额消费
  getConsumeDel(params){
    return post('/api/invoice/warn/consume/del', params)
  },

  // 产品分类
  getProductCategory(params){
    return post('/api/product/category', params)
  },

  // 提现金额
  getWithdraw(params){
    params = qs.stringify(params)
    return get('/api/withdraw/account', params)
  },
  // 充值记录
  getRecharge(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/bill/withdrawable', params)
  },
  // 提现记录
  getWithdrawLog(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/bill/withdrawn', params)
  },
  // 提现申请
  sendWithdrawApply(params){
    return post('/zsc/web/console/bill/withdraw', params)
  },

  // 佣金 - 提现账号信息
  getAccountInfo(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/user/invite/withdraw/account/info', params)
  },
  //  佣金 - 提现账号信息更新
  changeAccountUpdate(params){
    return post('/zsc/web/console/user/invite/withdraw/account/update', params)
  },
  // 佣金 - 提现申请
  getWithdrawApply(params) {
    return post('/zsc/web/console/user/invite/withdraw/apply', params)
  },
  // 佣金 - 奖励记录
  getCashlist(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/cash/list', params)
  },
  // 佣金 - 提现记录
  getWithdrawlist(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/user/invite/withdraw/list', params)
  },

  // 延停服务短信验证码
  getDeferstopCode(params){
    return post('/zsc/web/console/service/sms/send', params)
  },

  // 学生认证邮箱验证码 
  sendStuEmail(params) {
    return post('/zsc/web/console/service/email/send', params)
  },

  // 重置密码短信验证码
  getResetCode(params){
    return post('/zsc/web/console/service/sms/send', params)
  },

  // 绑定邮箱发送邮件
  getResetEmail(params){
    return post('/api/email/reset/send', params)
  },

  // 提现短信
  getWithdrawCode(params){
    return post('/zsc/web/console/service/sms/send', params)
  },
  // 账户信息
  getAccountInformation(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/pay/config', params)
  },
  // 在线充值交易状态查询
  getPayStatus(params){
    params = qs.stringify(params)
    return get('/zsc/web/console/pay/status', params)
  },

  
  // 开票数据
  invoiceStat(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/invoice/stat', params)
  },
  // 发票信息
  invoiceInfo(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/invoice/info', params)
  },
  // 开票记录
  invoiceList(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/invoice/record/list', params)
  },

  // 保存发票信息
  infoSave(params) {
    return post('/zsc/web/console/invoice/info/save', params)
  },
  // 保存邮寄地址
  addressSave(params) {
    return post('/zsc/web/console/invoice/address/save', params)
  },
  // 保存邮箱
  emailSave(params) {
    return post('/zsc/web/console/invoice/email/save', params)
  },
  
  
  // 开票
  invoiceCreate(params) {
    return post('/zsc/web/console/invoice/create', params)
  },
  // 发票内容
  invoiceContent(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/invoice/content/list', params)
  },
  // 账单列表
  billList(params) {
    params = qs.stringify(params)
    return get('/zsc/web/console/invoice/bill/list', params)
  },



}



// WEBPACK FOOTER //
// ./src/api/public/financial_api.js